/*
 * Break screen (SLATE-1, docs/slate.md): when OBS stops sending video, viewers see a
 * "be right back" screen on every platform until OBS is back or the time is up (then
 * the platforms close, as at the end of the hold). A stream key's setting:
 * slate_enabled (on by default), slate_after_ms (2–60 s, null = 5 s) and slate_max_ms
 * (10–600 s, null = as long as the hold, never longer). The form edits whole seconds.
 */

export const SLATE_AFTER_DEFAULT_S = 5
export const SLATE_AFTER_MIN_S = 2
export const SLATE_AFTER_MAX_S = 60
export const SLATE_MAX_MIN_S = 10
export const SLATE_MAX_MAX_S = 600

/** Seconds typed into a field → ms; empty = null (the default); bad = whole seconds out of min..max. */
export function parseSeconds(text: string, min: number, max: number): { ms?: number | null; bad?: boolean } {
  const s = text.trim()
  if (!s) return { ms: null }
  if (!/^\d+$/.test(s)) return { bad: true }
  const n = Number(s)
  if (n < min || n > max) return { bad: true }
  return { ms: n * 1000 }
}

/** "0:42", "12:05": what is left of the break screen. */
export function leftText(untilIso: string, now: number): string {
  const s = Math.max(0, Math.ceil((Date.parse(untilIso) - now) / 1000))
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`
}
